import { Injectable, inject } from "@angular/core";
import { RealTimeDataStore } from "@app/services/store/real-time-data-store";
import { WebStompEntitySubscriber } from "@app/services/webstomp/web-stomp-entity-subscriber.service";
import { VisitBookingReason } from "@app/models/rest/visit-booking-reason";
import { VisitBookingReasonRestService } from "@app/services/hal/visit-booking-reason.service";
import { HateoasResourceService } from "@lagoshny/ngx-hateoas-client";

@Injectable({
  providedIn: "root"
})
export class VisitBookingReasonStore extends RealTimeDataStore<VisitBookingReason> {
  constructor() {
    const visitBookingReasonRestService = inject(VisitBookingReasonRestService);
    const webStompSubscriber = inject(WebStompEntitySubscriber);
    const hateoasResourceService = inject(HateoasResourceService);

    super(
      visitBookingReasonRestService,
      webStompSubscriber,
      hateoasResourceService
    );
    super.subscribeToMessaging("VisitBookingReason");
  }
}
